
let abc = []
export default {
  props: {
    width: {
      type: [Number, String],
      default: 600,
    },
    areas: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    selectArea: {
      type: Boolean,
      default: true,
    },
  },
  // data() {
  //   return {
  //     area: null,
  //   }
  // },
  methods: {
    checkAreaSelected(ara) {
      let res = false
      console.log(ara)
      console.log(this.areas)
      this.areas.forEach(el => {
        if (el === ara) {
          res = true
        }
      })
      return res
    },
    mapAreaSelected(val) {
      console.log(abc)

      console.log(this.multiple)
      if (this.multiple) {
        console.log(typeof abc)

        console.log(abc)
        if (abc.filter(el => el === val).length) {
          const index = abc.indexOf(val)
          if (index > -1) {
            // only splice array when item is found
            abc.splice(index, 1) // 2nd parameter means remove one item only
          }
        } else {
          abc.push(val)
        }
      } else {
        abc = val
      }
      if (this.selectArea) {
        this.$emit('mapAreaSelected', abc)
      }
    },
  },
  destroyed() {
    console.log('destroyed')
    abc = []
  },
}
